'use strict';
import angular from 'angular';
var CreditCardListController = /** @class */ (function () {
    /*@ngInject*/
    function CreditCardListController($log, $filter, $scope, $mdDialog, CreditCardService, AddressService, $window) {
        this.sortType = 'name'; // set the default sort type
        this.sortReverse = false; // set the default sort order
        this.nickname = null;
        // set the default amount of items being displayed
        this.limit = 10;
        this.showViewMore = false;
        this.showAlert = false;
        this.account_btn_toggle_defultCC = true;
        // loadMore function
        this.loadMore = function () {
            var incremented = this.limit + 10;
            this.limit = incremented > this.creditCards.length ? this.creditCards.length : incremented;
            console.log('Limit is..' + this.limit);
            if (incremented > this.creditCards.length) {
                this.showViewMore = false;
            }
            else {
                this.showViewMore = true;
            }
        };
        this.creditCardBeingEdited = null;
        this.defaultCreditCard = null;
        this.errors = {};
        this.formSubmitted = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        var self = this;
        this.creditCardService = CreditCardService;
        this.addressService = AddressService;
        this.$log = $log;
        this.$scope = $scope;
        this.$scope.creditCard = {};
        this.$scope.billingAddress = {};
        this.$filter = $filter;
        this.getCreditCards();
        this.$mdDialog = $mdDialog;
        this.$window = $window;
        $scope.isLoading = true;
        // Listening to the event from submit button in parent (container) template
        $scope.$on('creditCardErrors', function (event, data) {
            if (data.errors[0].code === 1027) {
                //Invalid credit card number
                self.errors.havePageErrors = false;
                self.invalidErrorMessage = data.errors[0].message;
                $scope.ccForm.ccNumber.$valid = false;
                $scope.ccForm.ccNumber.$invalid = true;
                $scope.ccForm.ccNumber.$error = { 'invalid': true };
            }
            else {
                //display this message at the top of the modal.
                console.log('Error API');
                self.errors.pageErrors = data.errors;
                self.errors.pageErrorType = 'api';
                self.errors.havePageErrors = true;
                self.showAlert = true;
            }
        });
        //Child component address-form  will send this message.
        $scope.$on('publishedAddress', function (event, data) {
            self.$scope.billingAddress = data;
        });
        //Child component credit-card-form  will send this message.
        $scope.$on('publishedCreditCard', function (event, data) {
            self.$scope.creditCard = data;
            self.isCardSetDefault = false;
            self.creditCards.forEach(function (carditem) {
                if (carditem.isDefaultPayment) {
                    self.isCardSetDefault = true;
                }
            });
            if (!self.isCardSetDefault) {
                self.$scope.creditCard.isDefaultPayment = true;
            }
            self.getCreditCards();
            self.editCreditCard(null);
        });
        //Child component credit-card-form  will send this message whenever any credit card details are changed.
        $scope.$on('updatedCreditCard', function (event, data) {
            self.updateCreditCardDetails(data);
        });
        //Child component address-form  will send this message whenever any credit card details are changed.
        $scope.$on('updatedAddress', function (event, data) {
            self.$log.debug('address updated is......', data);
            self.updateCreditCardAddressDetails(data);
        });
        this.$scope.$watchGroup(['creditCard', 'billingAddress'], function (newValue, oldValue, scope) {
            if (newValue[0] != oldValue[0] && newValue[1] != oldValue[1]) {
                var creditCardDetails = newValue[0];
                var addressDetails = newValue[1];
                var newCreditCard = angular.extend(creditCardDetails, addressDetails);
                newCreditCard.firstName = creditCardDetails.firstName;
                newCreditCard.lastName = creditCardDetails.lastName;
                self.addNewCreditCard(newCreditCard);
            }
        });
        this.addressService.getAddresses()
            .then(function (response) {
            self.addresses = response.currentPage;
        }, function (response) {
        });
    }
    CreditCardListController.prototype.onCardValidation = function (args) {
        this.ccNumberInvalid = args.ccNumberInvalid;
    };
    CreditCardListController.prototype.updateCreditCardAddressDetails = function (data) {
        var self = this;
        for (var i in self.creditCards) {
            if (self.creditCards[i].billingAddress.addressId == data.addressId) {
                //This credit card details is updated; so update the list.
                self.$log.debug('Found the credit card to be updated for address!');
                self.creditCards[i].billingAddress = data;
                break; //Stop this loop, we found it!
            }
        }
    };
    CreditCardListController.prototype.updateCreditCardDetails = function (data) {
        var self = this;
        for (var i in self.creditCards) {
            if (self.creditCards[i].creditCardId == data.creditCardId) {
                //This credit card details is updated; so update the list.
                self.$log.debug('Found the credit card to be updated!', data);
                self.creditCards[i] = data;
                if (data.isDefaultPayment) {
                    console.log('Updated the default CC');
                    self.defaultCreditCard = data;
                }
                break; //Stop this loop, we found it!
            }
        }
    };
    CreditCardListController.prototype.deleteCardDialog = function ($event, modalId, card) {
        var self = this;
        self.cardDeleting = card;
        this.$mdDialog.show({
            scope: self.$scope,
            preserveScope: true,
            contentElement: modalId,
        });
    };
    CreditCardListController.prototype.closeDialog = function (modalId) {
        this.formSubmitted = false;
        if (modalId) {
            this.$mdDialog.hide({ contentElement: modalId });
        }
        else {
            this.$mdDialog.hide();
        }
        //this.$window.location.reload();
        this.$scope.$broadcast('creditCardFormReset', {});
    };
    CreditCardListController.prototype.addNewCreditCard = function (creditCard) {
        var self = this;
        this.showAlert = false;
        self.$log.debug('Add this credit card:', creditCard);
        this.creditCardService.addCreditCard(creditCard)
            .then(function (response) {
            self.$log.debug('After adding credit card, response is...', response);
            if (!response) {
                //Some error occurred when adding new credit card. communicate this back to user.
                self.$scope.$broadcast('creditCardErrors', { errors: 'fail to get payment information.' });
                self.formSubmitted = false;
                return;
            }
            var newCreditCard = response;
            //Make existing default credit card as normal credit card.
            if (newCreditCard.isDefaultPayment) {
                self.resetExistingDefaultCreditCard();
                self.defaultCreditCard = newCreditCard;
            }
            self.creditCardBeingEdited = null;
            self.creditCards.unshift(newCreditCard);
            self.closeDialog();
            self.$window.location.reload();
        });
    };
    CreditCardListController.prototype.isExpired = function (creditCard) {
        if (creditCard) {
            //Check if it is an expired credit card
            var parts = creditCard.expirationDate.split('/');
            var today = new Date();
            //var currentMonth = today.getMonth() + 1;
            //var currentYear = today.getYear();
            var cardDate = new Date(parts[1], parts[0]);
            /*if(currentYear > parts[1]) {
              return true;
            }
            if(currentMonth > parts[0]) {
              return true;
            }*/
            if (today > cardDate) {
                return true;
            }
            return false;
        }
        else {
            return false;
        }
    };
    CreditCardListController.prototype.getCreditCards = function () {
        var self = this;
        //We will only display credit cards that have valid creditCardId
        this.creditCardService.getCreditCards().then(function (data) {
            self.creditCards = data.filter(function (x) {
                return x.creditCardId ? true : false;
            });
            var defaultCreditCards = self.$filter("filter")(self.creditCards, { isDefaultPayment: true });
            if (defaultCreditCards) {
                self.defaultCreditCard = defaultCreditCards[0];
                self.$log.debug('default credit card is..', self.defaultCreditCard);
                self.limit = self.limit - 1;
            }
            if (self.creditCards && self.creditCards.length > self.limit) {
                self.showViewMore = true;
            }
        });
    };
    CreditCardListController.prototype.submitForm = function ($event) {
        $event.preventDefault();
        this.formSubmitted = true;
        console.debug('broadcast the message!');
        this.$scope.$broadcast('publishCreditCardDetails', {});
    };
    CreditCardListController.prototype.editCreditCard = function (creditCardId) {
        this.creditCardBeingEdited = creditCardId;
    };
    CreditCardListController.prototype.resetExistingDefaultCreditCard = function () {
        //make current default credit card as NOT the default one
        for (var i in this.creditCards) {
            if (this.creditCards[i].isDefaultPayment) {
                this.creditCards[i].isDefaultPayment = false;
                this.defaultCreditCard = null;
                break; //Stop this loop, we found it!
            }
        }
    };
    CreditCardListController.prototype.setAsDefaultCreditCard = function (creditCardId) {
        this.$log.debug('Set this credit card as default..' + creditCardId);
        var self = this;
        self.account_btn_toggle_defultCC = true;
        this.resetExistingDefaultCreditCard();
        this.creditCardService.setDefaultCreditCard(creditCardId)
            .then(function (response) {
            self.$log.debug('After making credit card default, the response is...', response);
            for (var i in self.creditCards) {
                if (self.creditCards[i].creditCardId == creditCardId) {
                    //This credit card details is updated; so update the list.
                    self.$log.debug('Found the credit card to be updated!');
                    self.creditCards[i].isDefaultPayment = true;
                    self.defaultCreditCard = self.creditCards[i];
                    break; //Stop this loop, we found it!
                }
            }
        });
    };
    CreditCardListController.prototype.deleteCreditCard = function (creditCard) {
        var self = this;
        if (creditCard == self.defaultCreditCard) {
            self.defaultCreditCard = null;
        }
        this.creditCards = this.creditCards.filter(function (x) {
            return x.creditCardId != creditCard.creditCardId;
        });
        this.creditCardService.deleteCreditCard(creditCard.creditCardId)
            .then(function (response) {
            self.$log.debug('After deleting credit card response is...', response);
            if (response.status === 200) {
                self.closeDialog('#delete-modal');
            }
            else {
                console.log(response);
            }
        });
    };
    CreditCardListController.prototype.creditCardsSortMethod = function (sortType) {
        var self = this;
        return function (item) {
            if (sortType === "expirationDate") {
                var splitResult = item.expirationDate.split("/");
                return new Date(splitResult[1], splitResult[0]);
            }
            else if (sortType === "cardType") {
                return self.creditCardService.cardTypes.filter(function (type) { return type.typeId == item.cardType; })[0].name;
            }
            else {
                return item[sortType];
            }
        };
    };
    return CreditCardListController;
}());
export default CreditCardListController;
//# sourceMappingURL=credit-card-list.controller.js.map